

import * as React from "react";
import * as $ from 'jquery';
import { FormControlProps } from "../interfaces/FormControlProps";
import { Field } from 'formik';

class Hidden extends React.Component<FormControlProps> {
  constructor(props : FormControlProps) {
    super(props);
  }

  render() {
    return <React.Fragment>
        <input className="hidden"
        name={this.props.formFieldDefinition.name}
        id={this.props.formFieldDefinition.name}
        ref={this.props.formFieldDefinition.name}
        type="hidden"
        value={this.props.field.value != null ? this.props.field.value : ""}        
        />
      </React.Fragment>;
  }
}

export { Hidden };